
























import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { LotInfo } from '~/models'
import globalStyling from '~/mixins/globalStyling'

@Component({})
export default class AttributeDetails extends mixins(globalStyling) {
  @Prop({ default: null }) lotInfo: LotInfo
  @Prop({ default: null }) lotType: string

  formatKey(key: string): string {
    return key
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  }

  formatSize(size: string): string {
    return (
      size.replace(/'/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' Sq Ft'
    )
  }

  get attributeDetails() {
    const existingFields = {
      neighborhood: this.lotInfo.neighborhood,
      property_type: this.lotInfo.property_type,
      size:
        this.lotType === 'home site' && this.lotInfo.size !== '-'
          ? this.formatSize(this.lotInfo.size as string)
          : null,
    }

    const attributeDetails = Object.fromEntries(
      Object.entries({
        ...existingFields,
        ...this.lotInfo.attributes,
      }).filter(([_, value]) => value)
    )

    return attributeDetails
  }
}
